if (document.querySelector('.stacker-row')) {

//Tabs
    const tabs = document.querySelectorAll('[data-tab-target]')
    const tabContents = document.querySelectorAll('[data-tab-content]')

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const target = document.querySelector(tab.dataset.tabTarget)
            tabContents.forEach(tabContent => {
                tabContent.classList.remove('active')
            })
            tabs.forEach(tab => {
                tab.classList.remove('active')
            })
            tab.classList.add('active')
            target.classList.add('active')

            //add the target name as a class for the stackercontainer
            stackerContainer.classList = 'stacker-row row ' + tab.dataset.tabTarget.substring(1);

            // The floorplans tab must always have a plan showing — if the user
            // deselected on the stacker tab, fall back to the default floor.
            if (tab.dataset.tabTarget === '#floorplans-tab' && !document.querySelector('ul.levels li.level.active:not(.total)') && defaultFloor) {
                defaultFloor.click();
            }
        })
    })


    const stackerContainer = document.querySelector('.stacker-row');
    const floorLevelsList = document.querySelectorAll('ul.levels li:not(.total)');
    // const floorKeysContainer = document.querySelectorAll('div.floor-keys');
    const floorKeysList = document.querySelectorAll('div.floor-keys ul');
    const totalItem = document.querySelector('ul.levels li.total');
    const StackerLevels = document.querySelectorAll('.floors-container .floor');
    const floorPlans = document.querySelectorAll('ul.floorplans li.floorplan');

// Find the index when a Floor Level is clicked, and then set active on a stacker level with the same index
    floorLevelsList.forEach((floor, index) => {
        floor.addEventListener('click', function () {
            // Let floors can't be selected; rows with no artwork can't be
            // selected on the stacker tab (nothing would light up), but can on
            // the floorplans tab where they have a plan to show.
            if (floor.classList.contains('let-floor')) {
                return;
            }
            if (floor.classList.contains('no-artwork') && !stackerContainer.classList.contains('floorplans-tab')) {
                return;
            }
            // Clicking the selected floor again deselects it and returns the
            // drawing to neutral — on the stacker tab only, since the floorplans
            // tab always needs a plan on show.
            if (floor.classList.contains('active') && !stackerContainer.classList.contains('floorplans-tab')) {
                clearActiveFloor();
                return;
            }
            setActiveFloor(index);
        });

        floor.addEventListener('mouseover', function () {
            // Let floors get a subtle hover on the drawing rather than none
            activeFloorHover(index, floor.classList.contains('let-floor'));
        });

        floor.addEventListener('mouseout', function () {
            activeFloorHoverOut(index);
        });

    });


// Interactivity on the "total" li item
    totalItem.addEventListener('click', function () {
        floorLevelsList.forEach(floor => {
            floor.classList.remove('active');
        });
        StackerLevels.forEach(level => {
            level.classList.remove('active');
        });
        // floorPlans.forEach(level => {
        //     level.classList.remove('active');
        // });

        totalItem.classList.add('active');
    });

    totalItem.addEventListener('mouseover', function () {
        // Highlight only the available floors — let floors stay dark, matching
        // the total figure, which excludes them
        StackerLevels.forEach((level, index) => {
            if (floorLevelsList[index] && floorLevelsList[index].classList.contains('let-floor')) {
                return;
            }
            level.classList.add('active-hover');
        });

    });

    totalItem.addEventListener('mouseout', function () {
        StackerLevels.forEach(level => {
            level.classList.remove('active-hover');
        });
    });


    // Floorplans and floor-keys are only rendered for non-let floors (see
    // get_floorplans() in includes/stacker-block-functions.php), whereas the
    // levels list and the stacker both contain every floor. Translate a
    // full-list index into the matching floorplan index by skipping any let
    // floors that come before it.
    function floorPlanIndexFor(index) {
        let planIndex = 0;
        for (let i = 0; i < index; i++) {
            if (!floorLevelsList[i].classList.contains('let-floor')) {
                planIndex++;
            }
        }
        return planIndex;
    }

    function clearActiveFloor() {
        floorLevelsList.forEach(floor => {
            floor.classList.remove('active');
        });
        StackerLevels.forEach(level => {
            level.classList.remove('active');
        });
        floorPlans.forEach(level => {
            level.classList.remove('active');
        });
        floorKeysList.forEach(key => {
            key.classList.remove('active');
        });
        totalItem.classList.remove('active');
    }

    function setActiveFloor(index) {
        clearActiveFloor();

        const floor = floorLevelsList[index];
        if (!floor) {
            return;
        }

        // Levels and stacker share the full floor list, so they map 1:1 by index
        floor.classList.add('active');
        if (StackerLevels[index]) {
            StackerLevels[index].classList.add('active');
        }

        // Let floors have no floorplan or keys, so only sync those for real floors
        if (!floor.classList.contains('let-floor')) {
            const planIndex = floorPlanIndexFor(index);
            if (floorPlans[planIndex]) {
                floorPlans[planIndex].classList.add('active');
            }
            if (floorKeysList[planIndex]) {
                floorKeysList[planIndex].classList.add('active');
            }
        }

        totalItem.classList.remove('active');
    }

    function activeFloorHover(index, subtle) {

        StackerLevels.forEach(level => {
            level.classList.remove('active-hover', 'let-hover');
        });
        StackerLevels[index].classList.add('active-hover');
        if (subtle) {
            StackerLevels[index].classList.add('let-hover');
        }
    }

    function activeFloorHoverOut(index) {
        StackerLevels.forEach(level => {
            level.classList.remove('active-hover', 'let-hover');
        });
    }

// Nothing is selected on load — the stacker shows the neutral drawing. This
// default is only used when the floorplans tab is opened with no selection,
// since that panel needs a plan on show. It prefers a floor with artwork so
// the drawing lights up if the user then switches back.
    const defaultFloor = Array.from(floorLevelsList).find((floor, i) => {
        return !floor.classList.contains('let-floor') && StackerLevels[i] && StackerLevels[i].querySelector('img');
    }) || Array.from(floorLevelsList).find(floor => !floor.classList.contains('let-floor')) || floorLevelsList[0];

//     // End Tabs
//
// 		// Reset tab order
// 		// resetTabOrderEl.focus();
//
// 		bodyScrollLock.clearAllBodyScrollLocks();
// 		scrollLock = 0;
// 	}
// }
//
// function openMenu() {
// 	if (menuOpen == 0) {
// 		menuOpen = 1;
// 		r.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
// 		// hamburgerIcon.focus();
// 	}
// }
//

} //